(function () {
  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  class Slider {
    constructor(root) {
      this.root = root;
      this.viewport = qs(root, '.HeroSlider__viewport');
      this.track = qs(root, '[data-track]');
      this.slides = qsa(root, '[data-slide]');
      this.prevBtn = qs(root, '[data-prev]');
      this.nextBtn = qs(root, '[data-next]');
      this.dotsWrap = qs(root, '[data-dots]');

      // 無限ループは常に有効（セクション設定の loop は使わない）
      this.loop = true;
      this.autoplay = root.dataset.autoplay === 'true';
      this.interval = Math.max(500, parseInt(root.dataset.interval || '3000', 10));
      
      this.baseSlides = this.slides.length;
      this.clonesBefore = 0;
      this.index = 0;              // track 内での現在位置
      this.timer = null;
      this.isAnimating = false;
      this.duration = 600;         // ← スライド時間（ms）ここで調整
      this.clickPrevent = false; 

      this.pointer = { active: false, startX: 0, deltaX: 0, id: null };

      this._setup();
      this._bind();
      this._update();
      this._startAutoplayIfNeeded();
    }

    _setup() {
      if (this.baseSlides === 0) return;

      if (this.loop && this.baseSlides > 1) {
        const originals = Array.from(this.slides);

        // 後ろにクローン
        originals.forEach(s => {
          const clone = s.cloneNode(true);
          clone.setAttribute('data-clone', '1');
          this.track.appendChild(clone);
        });

        // 前にクローン（逆順）
        originals.slice().reverse().forEach(s => {
          const clone = s.cloneNode(true);
          clone.setAttribute('data-clone', '1');
          this.track.insertBefore(clone, this.track.firstChild);
        });

        this.slides = qsa(this.root, '[data-slide]');
        this.clonesBefore = this.baseSlides;
        this.index = this.clonesBefore;
      } else {
        this.index = 0;
      }

      // 初期配置は「中央にジャンプ」（アニメなし）
      this._translate(0, false);

      // ドット（バー）生成
      if (this.dotsWrap) {
        this.dotsWrap.innerHTML = '';
        for (let i = 0; i < this.baseSlides; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', `Go to slide ${i + 1}`);
          b.innerHTML = `
            <svg width="18" height="2" viewBox="0 0 18 2" aria-hidden="true" focusable="false">
              <rect x="0" y="0" width="18" height="2" rx="1" ry="1"></rect>
            </svg>
          `;
          b.addEventListener('click', () => this.goToReal(i));
          this.dotsWrap.appendChild(b);
        }
      }

    }

    _bind() {
      // 矢印
      if (this.prevBtn) {
        this._onPrevClick = () => this.prev();
        this.prevBtn.addEventListener('click', this._onPrevClick);
      }
      if (this.nextBtn) {
        this._onNextClick = () => this.next();
        this.nextBtn.addEventListener('click', this._onNextClick);
      }

      // スワイプ（PCドラッグ / タッチ）
      this._boundPointerDown = this._onPointerDown.bind(this);
      this._boundPointerMove = this._onPointerMove.bind(this);
      this._boundPointerUp   = this._onPointerUp.bind(this);

      this.root.addEventListener('pointerdown', this._boundPointerDown);
      window.addEventListener('pointermove', this._boundPointerMove);
      window.addEventListener('pointerup', this._boundPointerUp);
      window.addEventListener('pointercancel', this._boundPointerUp);

      // リサイズ
      this._onResize = this._onResize.bind(this);
      window.addEventListener('resize', this._onResize);

      // ページ非表示でオートプレイ停止
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._stopAutoplay();
        else this._startAutoplayIfNeeded();
      });
    }

    _onResize() {
      this._translate(0, false);
    }

    _onPointerDown(e) {
      // マウス → 左クリックのみ、タッチ → 常にOK
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      // スライダー外は無視
      if (!e.target.closest('.HeroSlider__track')) return;

      // 矢印 or ドットボタンの上ではスワイプさせず、クリック扱いにする
      if (e.target.closest('[data-prev],[data-next],.HeroSlider__dots button')) return;

      this.clickPrevent = false;   
      this.pointer.active = true;
      this.pointer.startX = e.clientX;
      this.pointer.deltaX = 0;
      this.pointer.id = e.pointerId;

      this.track.style.transition = 'none';
      this._stopAutoplay();

      // ネイティブドラッグ/テキスト選択を抑止
      e.preventDefault();
    }



    _onPointerMove(e) {
      if (!this.pointer.active) return;
      if (this.pointer.id != null && e.pointerId !== this.pointer.id) return;
      this.pointer.deltaX = e.clientX - this.pointer.startX;
      this._translate(this.pointer.deltaX, false);
      //ドラッグとみなすしきい値（px）
      const dragThreshold = 5;
      if (Math.abs(this.pointer.deltaX) > dragThreshold) {
        this.clickPrevent = true;
      }
      e.preventDefault();
    }
    _onClick(e) {
      // スライド内のリンク/カードだけを対象にする
      const linkEl = e.target.closest('[data-slide-link]');
      if (!linkEl) return;

      // ドラッグ操作由来なら遷移を止める
      if (this.clickPrevent) {
        e.preventDefault();
        e.stopPropagation();
        this.clickPrevent = false;  // 次の操作のためリセット
      }
    }
    _onPointerUp(e) {
      if (!this.pointer.active) return;
      if (this.pointer.id != null && e.pointerId !== this.pointer.id) return;
      const threshold = this._slideSize() * 0.03; // 3% くらいまで緩める
      if (Math.abs(this.pointer.deltaX) > threshold) {
        // ドラッグとして扱う: スライドを送り、直後のクリックをキャンセル
        if (this.pointer.deltaX > threshold) this.prev();
        else if (this.pointer.deltaX < -threshold) this.next();

        const cancelClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          this.root.removeEventListener('click', cancelClick, true);
        };
        this.root.addEventListener('click', cancelClick, true);
      } else {
        // 十分に動いていなければ元の位置に戻し、クリックはブラウザに任せる
        this._translate(0, true);
      } 

      if (this.track.releasePointerCapture) {
        try { this.track.releasePointerCapture(e.pointerId); } catch (err) {}
      }

      this.pointer.active = false;
      this.pointer.deltaX = 0;
      this.pointer.id = null;
      this._startAutoplayIfNeeded();
    }

    _slideSize() {
      const slide = this.slides[this.index] || this.slides[0];
      if (!slide) return 0;
      const rect = slide.getBoundingClientRect();
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || getComputedStyle(this.root).getPropertyValue('--gutter') || 0);
      return rect.width + gap;
    }

    _translate(deltaX = 0, withTransition = true) {
      const slide = this.slides[this.index];
      if (!slide || !this.viewport) return;

      const slideRect = slide.getBoundingClientRect();
      const vpRect = this.viewport.getBoundingClientRect();

      const slideWidth = slideRect.width;
      const centerOffset = vpRect.width / 2 - slideWidth / 2;

      const step = this._slideSize();
      const baseOffset = centerOffset - this.index * step;

      if (withTransition) {
        this.track.style.transition = 'transform ' + this.duration + 'ms ease';
      } else {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translate3d(${baseOffset + deltaX}px, 0, 0)`;
    }

    _realIndex() {
      if (!this.loop) {
        return Math.max(0, Math.min(this.index, this.baseSlides - 1));
      }
      const i = (this.index - this.clonesBefore) % this.baseSlides;
      return (i + this.baseSlides) % this.baseSlides;
    }

    _normalizeIndex() {
      if (!this.loop || this.baseSlides <= 1) return;

      const firstReal = this.clonesBefore;
      const lastReal = this.clonesBefore + this.baseSlides - 1;

      if (this.index < firstReal) {
        this.track.style.transition = 'none';
        this.index += this.baseSlides;
        this._translate(0, false);
      } else if (this.index > lastReal) {
        this.track.style.transition = 'none';
        this.index -= this.baseSlides;
        this._translate(0, false);
      }
    }

    _update() {
      const realIndex = this._realIndex();

      if (this.dotsWrap) {
        qsa(this.dotsWrap, 'button').forEach((b, i) => {
          if (i === realIndex) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      }

      this.slides.forEach((el, idx) => {
        if (idx === this.index) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
    }

    goToReal(i) {
      if (this.baseSlides === 0) return;

      // タイマーリセット
      this._stopAutoplay();

      if (this.loop) {
        this.index = this.clonesBefore + i;
      } else {
        this.index = Math.max(0, Math.min(i, this.baseSlides - 1));
      }

      this._translate(0, true);
      this._normalizeIndex();
      this._update();

      // 再スタート
      this._startAutoplayIfNeeded();
    }

    _step() {
      if (this.baseSlides <= 0) return;
      this._update();
      this._translate(0, true);
      setTimeout(() => {
        this._normalizeIndex();
        this._update();
        this.isAnimating = false;
      }, this.duration + 20);
    }

    prev() {
      if (this.isAnimating || this.baseSlides <= 0) return;

      this._stopAutoplay();  // ← リセット

      this.isAnimating = true;
      this.index -= 1;
      this._step();

      this._startAutoplayIfNeeded(); // ← 終了後（_step 内の timeout を待たずに）再セット
    }
    next() {
      if (this.isAnimating || this.baseSlides <= 0) return;

      this._stopAutoplay();  // ← リセット

      this.isAnimating = true;
      this.index += 1;
      this._step();

      this._startAutoplayIfNeeded(); // ← 再セット
    }

    destroy() {
      // タイマー停止
      this._stopAutoplay();

      // リサイズイベント解除
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }

      // スワイプ関連イベント解除
      if (this._boundPointerDown) {
        this.root.removeEventListener('pointerdown', this._boundPointerDown);
        window.removeEventListener('pointermove', this._boundPointerMove);
        window.removeEventListener('pointerup', this._boundPointerUp);
        window.removeEventListener('pointercancel', this._boundPointerUp);
      }

      // 矢印ナビのイベント解除
      if (this.prevBtn && this._onPrevClick) {
        this.prevBtn.removeEventListener('click', this._onPrevClick);
      }
      if (this.nextBtn && this._onNextClick) {
        this.nextBtn.removeEventListener('click', this._onNextClick);
      }

      // クローンスライドを削除（data-clone=1 を全削除）
      if (this.track) {
        var clones = this.track.querySelectorAll('[data-clone]');
        if (clones.forEach) {
          clones.forEach((el) => el.remove());
        } else {
          Array.prototype.forEach.call(clones, function (el) {
            if (el.parentNode) el.parentNode.removeChild(el);
          });
        }
      }

      // ドットをリセット
      if (this.dotsWrap) {
        this.dotsWrap.innerHTML = '';
      }
    }

    _startAutoplayIfNeeded() {
      if (!this.autoplay) return;
      if (this.timer) return;
      this.timer = window.setInterval(() => {
        this.next();
      }, this.interval);
    }

    _stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  function mount(selectorOrElement) {
    var root =
      typeof selectorOrElement === 'string'
        ? document.querySelector(selectorOrElement)
        : selectorOrElement;
    if (!root) return;

    // 既存インスタンスがあればクリーンアップ
    if (root.__heroSlider) {
      try {
        root.__heroSlider.destroy();
      } catch (e) {}
    }
    root.__heroSlider = new Slider(root);
  }

  window.HeroSlider = { mount };
})();
